import { Modal } from "antd"
import { useDeleteInvoiceLineItem } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import type { InvoiceLineItemDto } from "@mimber/schema"

export const useDeleteInvoiceLineItemModal = (
  invoiceUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const deleteMutation = useDeleteInvoiceLineItem(invoiceUuid)

  const showDeleteInvoiceLineItemModal = (
    lineItem: InvoiceLineItemDto
  ): void => {
    modal.confirm({
      title: "Delete Line Item",
      content: `Are you sure you want to delete "${lineItem.name}"? This action cannot be undone.`,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          deleteMutation.mutate(
            { lineItemUuid: lineItem.uuid },
            {
              onSuccess: () => {
                message.success("Line item deleted")
                onSuccess?.()
                resolve()
              },
              onError: (error) => {
                message.error(`Failed to delete line item: ${error.message}`)
                reject()
              },
            }
          )
        }),
    })
  }

  return {
    contextHolder,
    showDeleteInvoiceLineItemModal,
  }
}
